import {Term} from './Term';
export default Term;
